module.exports = __webpack_public_path__ + "static/GL-b0be859931800cfb9ca63eaa0e63cbea.png";